import { createPromiseAction } from '@adobe/redux-saga-promise';

// Actions for listing events
export const listEvents = createPromiseAction('events/list');

// Actions for searching events
export const searchEvents = createPromiseAction('events/search');

// Actions for filtering events
export const filterEvents = createPromiseAction('events/filter');

// Actions for exporting events
export const exportEvents = createPromiseAction('events/export');

// Actions for viewing event details
export const getEventInfo = createPromiseAction('events/info');

// Actions for updating event info
export const updateEventInfo = createPromiseAction('events/updateInfo');

// Actions for adding a event
export const addEvent = createPromiseAction('events/add');
